.ux-iws-text-lines-limit {
    display: block;

    > *:first-child {
        overflow: visible;
        display: block;
    }
}
